import { Flex, Text } from '@enechain/ecloud-designsystem'
import { FaFileLinesRegularFull } from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'

type Props = {
  /** 選択したファイル名。 */
  name: string
  /** サイズと選択時刻 (例: 「38 KB ・ 選択 10:52」)。 */
  meta: string
}

/**
 * 選択済みファイルの情報 (common.md AC-DUC-005 / AC-DUC-006、 誤ファイル防止)。
 *
 * 見た目は design の `.up-file-info`: 灰色の地・淡い枠・角丸 md の 1 行に、
 * ファイル icon・ファイル名 (sm / semibold)・サイズと選択時刻 (xs / 中強調) を並べる。
 * 幅が足りない時はサイズと選択時刻が次の行に回る。
 */
export const CsvUploadFileInfo = ({
  name,
  meta,
}: Props): React.ReactElement => (
  <Flex
    alignItems="center"
    gap={3}
    background="Surface.secondary"
    borderWidth="1px"
    borderColor="Border.lowEmphasis"
    borderRadius="md"
    paddingX={3}
    paddingY={2}
  >
    <FaFileLinesRegularFull
      flexShrink={0}
      boxSize={iconSize.fileInfo}
      color="Text.midEmphasis"
      aria-hidden="true"
    />
    <Flex alignItems="baseline" flexWrap="wrap" columnGap={3}>
      <Text
        textStyle="captionStrong"
        color="Text.highEmphasis"
        wordBreak="break-all"
      >
        {name}
      </Text>
      <Text
        color="Text.midEmphasis"
        fontSize="xs"
        fontVariantNumeric="tabular-nums"
      >
        {meta}
      </Text>
    </Flex>
  </Flex>
)
